import { isEmpty } from 'validator';

import { queryString } from '@preventx/prismic-services';

// Types
import { ApplicationRerouteUrlRequest } from '@/types/routing/applications';

// Constants
import { ApplicationRouter_PortalId } from '@/constants/routing';

// Configuration
import { applicationEnv as clientEnv } from '@/configuration/clientApplicationEnv';
import { applicationEnv as serverEnv } from '@/configuration/serverApplicationEnv';

/** Will reroute the user to the appropriate application based on name and `PORTAL_ID` */
export const applicationRerouteUrl = ({
  params,
  application,
}: ApplicationRerouteUrlRequest) => {
  if (!application) {
    return null;
  }

  const { ApplicationUrls } = clientEnv;
  const {
    SecurePortalUrl,
    OrderTestBaseUrl,
    ConsultationBaseUrl,
    ServiceUserResultsBaseUrl,
  } = ApplicationUrls;

  const url = {
    'Order a Test': OrderTestBaseUrl,
    'Secure Portal': SecurePortalUrl,
    Consultation: ConsultationBaseUrl,
    'Service User Results': ServiceUserResultsBaseUrl,
  }[application];

  // Note : Possible this could still return empty if new items are added and not configured
  //        in here so this is a safety net
  if (isEmpty(url ?? '')) {
    return null;
  }

  const formattedUrl = url.replace(
    ApplicationRouter_PortalId,
    serverEnv.PortalId,
  );

  return params ? queryString(formattedUrl, params) : formattedUrl;
};
